// Constants for data types
export const DATA_TYPES = [
  { value: 'string', label: 'String' },
  { value: 'numeric', label: 'Numeric' },
  { value: 'decimal', label: 'Decimal' },
  { value: 'date', label: 'Date' },
  { value: 'time', label: 'Time' },
  { value: 'identifier', label: 'Identifier' },
] as const

// Constants for usage types
export const USAGE_TYPES = [
  { value: 'M', label: 'M (Mandatory)' },
  { value: 'O', label: 'O (Optional)' },
  { value: 'C', label: 'C (Conditional)' },
] as const

// Constants for main segment keys
export const MAIN_SEGMENT_KEYS = [
  'isa_segment',
  'gs_segment',
  'st_segment',
  'loops',
  'se_segment',
  'ge_segment',
  'iea_segment',
] as const

// Constants for main segment titles
export const MAIN_SEGMENT_TITLES = {
  isa_segment: 'Interchange Control Header',
  gs_segment: 'Functional Group Header',
  st_segment: 'Transaction Set Header',
  loops: 'Loops',
  se_segment: 'Transaction Set Trailer',
  ge_segment: 'Functional Group Trailer',
  iea_segment: 'Interchange Control Trailer',
} as const
